module.exports = __webpack_public_path__ + "static/media/contact.9284a0fb.png";